module.exports = __webpack_public_path__ + "img/Withdraw.8896e034.svg";